// 公用常量

// 上传附件pdf限制(单位:M)
export const PDF_LIMIT_SIZE = 1

// elementUI公用组件分页layout
export const PAGINATION_LAYOUT = 'total, sizes, prev, pager, next, jumper'
// 分页页码选择，默认页码应当是第一个，即：PAYE_NUMBER[0]
export const PAYE_NUMBER = [20, 30, 50, 100]

export const payStatusList=[
  {payTypeName:'用户付款',list:['未支付',"已支付","已取消","已关闭","已退款","审核中"]},
  {payTypeName:"用户退款",list:['待退款']},
]
export const orderTypeList=['预付费用',"其他费用","录用费用","加急费","增版费","查重费"]



// WEBPACK FOOTER //
// ./src/const/common.js